import { enqueueSnackbar } from "notistack";
import { debounce } from "../utilities/debounce";

export const fetchApi = async ({
  requestOptions,
  endpoint,
  headers = null,
  addBaseUrl = true,
  checkSession = true,
}) => {
  let response = "";
  try {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json, text/javascript, /; q=0.01");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Requested-With", "XMLHttpRequest");

    const myRequestOptions = {
      ...requestOptions,
      headers: headers || myHeaders,
    };
    const origin = window.location.origin;
    const url = addBaseUrl ? `${origin}${endpoint}` : endpoint;
    response = await fetch(url, myRequestOptions);
    // if (endpoint === "/web/login") {
    //   response.headers.forEach(function (val, key) {
    //     // console.log(key + " -> " + val);
    //   });
    // }
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    } else {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      } else {
        const checkResponse = await response.text();

        if (checkSession) {
          const parsedResponse = JSON.parse(checkResponse);
          // console.log("parsedResponse", parsedResponse);
          let parsedLC = parsedResponse.error?.message?.toLowerCase();
          if (parsedLC?.includes("odoo")) {
            parsedLC = parsedLC.replaceAll("odoo", "").toUpperCase();
          }
          const isPublicRoute =
            !window.location.href.includes("/merchant/homepage");
          // console.log("isPublicRoute", isPublicRoute);
          if (parsedResponse?.error?.code === 100 && !isPublicRoute) {
            debounce(
              async () => {
                enqueueSnackbar(parsedLC, {
                  action: () => (
                    <>
                      <button
                        style={{
                          marginLeft: 5,
                          fontSize: "0.875rem",
                          color: "white",
                          backgroundColor: "#ff5837",
                          fontWeight: "600",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          boxShadow: "initial",
                        }}
                        onClick={() => {
                          localStorage.clear();
                          window.location.reload();
                        }}
                      >
                        Reload
                      </button>
                    </>
                  ),
                  variant: "error",
                  persist: true,
                });
              },
              10,
              []
            );
          }
        }
        return checkResponse;
      }
    }
  } catch (error) {
    // if (endpoint === "/web/login") {
    //   response?.headers?.forEach(function (val, key) {
    //     // console.log(key + " -> " + val);
    //   });
    // }
    console.error("An error occurred:", error);
    // throw error; // Re-throw the error to propagate it to the caller
  }
};
